import React, { useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/shared/Navbar";
import { AuthContext } from "../components/ContextApi/ContextApi";
import ReceiptPreview from "./ReceiptPreview";
import { RawBTPrinter } from "../utils/rawbtPrinter";

export default function NewAccountReportBluetooth() {
  const { state } = useLocation();
  const accounts = state?.accounts || [];

  const { firstName, lastName, userMobile, bank } =
    useContext(AuthContext);

  // ================= HELPERS =================
  const formatAmount = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  const safe = (v) => (v ? v : "");

  // ✅ FIXED LABEL WIDTH (max label length = "Account No")
  const LABEL_WIDTH = 12;

  const labelLine = (label, value) =>
    `${label.padEnd(LABEL_WIDTH, " ")}: ${value}`;

  // ================= PREVIEW =================
  const previewText = useMemo(() => {
    if (!accounts.length) return "No new account reports found.";

    let lines = [];
    let total = 0;

    lines.push("**** NEW ACCOUNT REPORT ****");
    lines.push(bank || "");
    lines.push(`Date: ${new Date().toLocaleDateString()}`);
    lines.push(`Agent: ${firstName} ${lastName}`);
    lines.push("");
    lines.push("=".repeat(32));

    accounts.forEach((acc) => {
      const received = parseFloat(acc.Recieved) || 0;
      total += received;

      lines.push(labelLine("Account No", safe(acc.AccountNo)));
      lines.push(labelLine("Name", safe(acc.Name)));
      lines.push(labelLine("Date", safe(acc.OpenDate)));
      lines.push(labelLine("Amount", formatAmount(received)));
      lines.push("-".repeat(32));
    });

    lines.push(labelLine("TOTAL", formatAmount(total)));
    lines.push("=".repeat(32));
    lines.push("END OF REPORT");
    lines.push(`${firstName} ${lastName}`);
    lines.push(userMobile);

    return lines.join("\n");
  }, [accounts, bank, firstName, lastName, userMobile]);

  // ================= BLUETOOTH PRINT =================
  const handlePrintReport = () => {
    if (!accounts.length) {
      alert("No account data found to print!");
      return;
    }

    let commands = "";
    let total = 0;

    commands += "\x1B@";       // Init
    commands += "\x1Ba\x01";   // Center
    commands += "*** NEW ACCOUNT REPORT ***\n";
    commands += `${bank}\n`;
    commands += `Date: ${new Date().toLocaleDateString()}\n`;
    commands += `Agent: ${firstName} ${lastName}\n\n`;

    commands += "\x1Ba\x00";   // LEFT ALIGN
    commands += "=".repeat(32) + "\n";

    accounts.forEach((acc) => {
      const received = parseFloat(acc.Recieved) || 0;
      total += received;

      commands += labelLine("Account No", safe(acc.AccountNo)) + "\n";
      commands += labelLine("Name", safe(acc.Name)) + "\n";
      commands += labelLine("Date", safe(acc.OpenDate)) + "\n";
      commands += labelLine("Amount", formatAmount(received)) + "\n";
      commands += "-".repeat(32) + "\n";
    });

    commands += labelLine("TOTAL", formatAmount(total)) + "\n";
    commands += "=".repeat(32) + "\n\n";

    commands += "\x1Ba\x01";
    commands += "END OF REPORT\n";
    commands += `${firstName} ${lastName}\n`;
    commands += `${userMobile}\n\n\n`;

    RawBTPrinter.printEscPos(commands);
  };

  // ================= UI =================
  return (
    <div>
      <Navbar />

      <div
        style={{
          padding: "10px 20px",
          marginTop: "70px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={handlePrintReport}
            style={{
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
            }}
          >
            🖨 Print Full Report
          </button>
        </div>

        {/* ✅ FORCE LEFT + MONOSPACE PREVIEW */}
        <div style={{ marginTop: "20px", textAlign: "left" }}>
          <ReceiptPreview text={previewText} />
        </div>
      </div>
    </div>
  );
}
